const asset = require('./asset');
const dealer = require('./dealer');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log('employee', entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),

      visibleOnWeb: false,
      type: null,
      position: null,
      makesBlacklist: [],
      hideContactInfo: false
    };

    if (entry.fields.name && entry.fields.name['nb-NO']) {
      result.name = entry.fields.name['nb-NO'];
    }

    if (entry.fields.department && entry.fields.department['nb-NO']) {
      result.department = entry.fields.department['nb-NO'];
    }

    if (entry.fields.position && entry.fields.position['nb-NO']) {
      result.position = entry.fields.position['nb-NO'];
    }

    if (entry.fields.phone && entry.fields.phone['nb-NO']) {
      result.phone = entry.fields.phone['nb-NO'];
    }

    if (entry.fields.phoneOverride && entry.fields.phoneOverride['nb-NO']) {
      result.phoneOverride = entry.fields.phoneOverride['nb-NO'];
    }

    if (entry.fields.email && entry.fields.email['nb-NO']) {
      result.email = entry.fields.email['nb-NO'];
    }

    if (entry.fields.emailOverride && entry.fields.emailOverride['nb-NO']) {
      result.emailOverride = entry.fields.emailOverride['nb-NO'];
    }

    if (entry.fields.roles && entry.fields.roles['nb-NO']) {
      result.roles = entry.fields.roles['nb-NO'];
    }

    if (entry.fields.visibleOnWeb) {
      result.visibleOnWeb = entry.fields.visibleOnWeb['nb-NO'];
    }

    if (entry.fields.hideContactInfo) {
      result.hideContactInfo = entry.fields.hideContactInfo['nb-NO'];
    }

    /* if (entry.fields.visibleAsSalesperson) {
      result.visibleAsSalesperson = entry.fields.visibleAsSalesperson['nb-NO'];
    }*/

    if (entry.fields.mobile && entry.fields.mobile['nb-NO']) {
      result.mobile = entry.fields.mobile['nb-NO'];
    }

    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = asset.contentfulToInternal(entry.fields.image['nb-NO']);
    }

    if (entry.fields.dealer && entry.fields.dealer['nb-NO'] && isResolvedResource(entry.fields.dealer['nb-NO'])) {
      result.dealer = dealer.contentfulToInternal(entry.fields.dealer['nb-NO']);
    }

    if (entry.fields.type && entry.fields.type['nb-NO']) {
      result.type = entry.fields.type['nb-NO'];
    }

    if (entry.fields.makesBlacklist && entry.fields.makesBlacklist['nb-NO']) {
      result.makesBlacklist = entry.fields.makesBlacklist['nb-NO'];
    }

    return result;
  },

  internalToContentful(employee) {
    const result = {
      fields: {
        name: {
          'nb-NO': employee.name
        },
        department: {
          'nb-NO': employee.department
        },
        position: {
          'nb-NO': employee.position
        },
        phone: {
          'nb-NO': employee.phone
        },
        email: {
          'nb-NO': employee.email
        },
        visibleOnWeb: {
          'nb-NO': (employee.visibleOnWeb === 'true' || employee.visibleOnWeb === true)
        },
        hideContactInfo: {
          'nb-NO': (employee.hideContactInfo === 'true' || employee.hideContactInfo === true)
        },
        type: {
          'nb-NO': employee.type
        },
        emailOverride: null,
        phoneOverride: null,
        image: null,
        makesBlacklist: {
          'nb-NO': employee.makesBlacklist
        }
      }
    };

    if (employee.emailOverride) {
      result.fields.emailOverride = {
        'nb-NO': employee.emailOverride
      };
    }

    if (employee.phoneOverride) {
      result.fields.phoneOverride = {
        'nb-NO': employee.phoneOverride
      };
    }

    if (employee.image) {
      result.fields.image = {
        'nb-NO': createAssetLink(employee.image)
      };
    }

    if (employee.dealerLinkId) {
      result.fields.dealer = {
        'nb-NO': {
          sys: {
            type: 'Link',
            linkType: 'Entry',
            id: employee.dealerLinkId
          }
        }
      };
    }

    return result;
  }
};
